import { defineMessages } from 'react-intl';

export const trialEndDiscreetCardMessages = defineMessages({
  ariaLabel: {
    defaultMessage: 'Trial ended notification',
    id: 'oE2AOtrDga',
    description:
      'Accessible label for the post–trial-end discreet corner card; shown to low-usage users as a soft preview before the big upgrade modal',
  },
  title: {
    defaultMessage: 'Your complimentary access to Clinician has ended',
    id: 'zvGRHC5NlS',
    description:
      'Title on the post–trial-end discreet corner card for a solo Clinician trial (PRO → Scribe Plus); shown after the trial ends and before the user opens the upgrade modal',
  },
  titlePractice: {
    defaultMessage: 'Complimentary access to Evidence features has ended',
    id: 'sedswylZX9',
    description:
      'Title on the post–trial-end discreet corner card for a Practice admin trial (PRO_PLUS → Scribe Team); team-level wording (no "Your") referencing the Evidence features they lost',
  },
  description: {
    defaultMessage:
      "You're back on <emphasis>{planName}</emphasis> (formerly Heidi Pro). No billing changes.",
    id: 'iP+goNhB+f',
    description:
      'Body on the post–trial-end discreet corner card for the Clinician variant; planName is the paid tier they returned to (e.g. Scribe Plus). The <emphasis> wrapper renders the plan name as an underlined accent — not a link.',
  },
  descriptionPractice: {
    defaultMessage: "You're back on {planName} (formerly Practice). No billing change.",
    id: '0L/U9GVag4',
    description:
      'Body on the post–trial-end discreet corner card for the Practice admin variant; planName is the paid tier the team returned to (Scribe Team). No emphasis underline, "formerly Practice", singular "change" — matches the Figma copy.',
  },
  scribePlusPlanName: {
    defaultMessage: 'Scribe Plus',
    id: 'jT+n82ixjc',
    description:
      'Display name for Scribe Plus when describing the plan users return to after a Clinician trial ends on the discreet card',
  },
  scribeTeamPlanName: {
    defaultMessage: 'Scribe Team',
    id: 's0YqHAI1Oi',
    description:
      'Display name for Scribe Team when describing the plan a team returns to after a Practice trial ends on the discreet card',
  },
  learnMoreCta: {
    defaultMessage: 'Learn more',
    id: 'TLYfgZ4ofy',
    description:
      'Primary CTA on the post–trial-end discreet corner card; opens the full upgrade modal',
  },
  close: {
    defaultMessage: 'Close',
    id: 'VqixtfOuwL',
    description:
      'Accessible label for the close (×) icon button on the post–trial-end discreet corner card',
  },
});
